/**
 * Категорії матеріалу (MaterialType.category) і закупівлі (Purchase.category).
 * Мають збігатися з enum у models/MaterialType.js.
 */
export const MATERIAL_CATEGORY_OPTIONS = [
    { value: "FABRIC", label: "Тканина" },
    { value: "HARDWARE", label: "Фурнітура" },
    { value: "THREAD", label: "Нитки" },
    { value: "FILLING", label: "Наповнювач" },
    { value: "SUPPORT", label: "Допоміжні" },
    { value: "PACKAGING", label: "Упаковка" },
    /** Накати, вишивка на одязі тощо: облік у шт., колір у картці не використовується. */
    { value: "PRINTS_EMBROIDERY", label: "Накати та вишивка" },
];

/** Значення поля `color` у БД, коли колір не застосовується (унікальність typeId+color). */
export const MATERIAL_COLOR_NA_PLACEHOLDER = "—";

export const PRINTS_EMBROIDERY_CATEGORY = "PRINTS_EMBROIDERY";

export function isPrintsEmbroideryCategory(category) {
    return String(category || "").trim() === PRINTS_EMBROIDERY_CATEGORY;
}

export function materialCategoryLabel(value) {
    const row = MATERIAL_CATEGORY_OPTIONS.find((o) => o.value === value);
    return row ? row.label : value || "—";
}
